import { Component, OnInit } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { CommonService } from '../../../shared/services/common.service'
import { ActivatedRoute, Router } from '@angular/router'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
@Component({
  standalone: false,
  selector: 'app-plp-banner',
  templateUrl: './plp-banner.component.html',
  styleUrls: ['./plp-banner.component.scss'],
})
export class PlpBannerComponent implements OnInit {
  categoryId: any
  public categoryTypes
  public apiurl = environment.occBaseUrl
  sub: any

  constructor(
    private commonService: CommonService,
    private routes: ActivatedRoute,
    private globalMessageService: GlobalMessageService
  ) {}

  getCategoryDetails(categoryId) {
    this.categoryId = categoryId
    this.commonService
      .getData(
        environment.occBaseUrl +
          '/occ/v2/vsstore/vsCategories/' +
          this.categoryId
      )
      .subscribe(
        (success) => {
          this.categoryTypes = success
        },
        (error) => {
          this.globalMessageService.add(
            error,
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  ngOnInit(): void {
    this.sub = this.routes.params.subscribe(
      (params) => {
        // this.breadcrumbService.setBreadcrumbTitle(params.categoryId);
        this.categoryId = params['categoryId']
        this.getCategoryDetails(this.categoryId)
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }
}
